import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import style from "../../sass/pages/auth/auth-page.module.scss";
import { returnToPrevPath, setPathToAuthentication, setPathToProfile } from "../path/pathSlice";
import {
    registrationThunk,
    selectRegistrated,
    selectRegistrationError,
} from "./registrationSlice";
import { pushAlert } from "../alerts/alertSlice";
import { setAuthenticated } from "../authentication/authSlice";
import { validateEmail, validatePassword } from "./validates";
import { validateUserName } from "../authentication/validates";
import { useTranslation } from "react-i18next";
import { checkIsAdmin } from "../admin/adminSlice";

const RegistrationPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const registrated = useSelector(selectRegistrated);
    const error = useSelector(selectRegistrationError);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [userType, setUserType] = useState("individual");

    const handleButtonClick = async () => {
        let emailErr = validateEmail(email)
        let passwordErr = validatePassword(password)
        let nameErr = validateUserName(name)
        let errors = []
        
        if (emailErr) {
            errors.push(emailErr)
        }
        if (passwordErr) {
            errors.push(passwordErr)
        }
        if (nameErr) {
            errors.push(nameErr)
        }
        
        if (errors.length > 0) {
            errors.forEach((err) => {
                dispatch(pushAlert({
                    type: "danger",
                    message: t(err),
                    delay: 2000,
                }))
            })
            return
        }

        dispatch(
            registrationThunk({
                name,
                email,
                password,
                userType,
            })
        );
    };

    useEffect(() => {
        if (!registrated) {
            return;
        }
        dispatch(setPathToProfile());
        dispatch(checkIsAdmin())
    }, [registrated, dispatch, navigate]);

    const redirectToAuthentication = () => {
        dispatch(setAuthenticated(false))
        dispatch(setPathToAuthentication());
    };

    useEffect(() => {
        if (!error) {
            return;
        }
        dispatch(pushAlert({
            message: t(error),
            delay: 1000,
            type: "danger"
        }));
    }, [dispatch, error]);

    return (
        <div className={style.container}>
            <main className={style.main}>
                <div className={style.imageBlock}>
                    <img src="/static/images/png/profile-image.png" alt="" />
                </div>

                <div className={style.rightBlock}>
                    <span className={style.headline}>
                        {t("registration.header")}
                    </span>

                    <div className={style.inputBlock}>
                        <label className={style.inputLabel}>
                            <div className={style.inputSvgBlock}>
                                <img
                                    src="/static/images/svg/profile.svg"
                                    alt=""
                                />
                            </div>
                            {/* <img src="/static/images/svg/email.svg" alt="" /> */}
                            <input
                                className={style.input}
                                type="text"
                                value={name}
                                placeholder={t("registration.username")}
                                autoComplete="off"
                                onInput={(e) => setName(e.target.value)}
                            />
                        </label>

                        <label className={style.inputLabel}>
                            <div className={style.inputSvgBlock}>
                                <img
                                    src="/static/images/svg/email.svg"
                                    alt=""
                                />
                            </div>
                            {/* <img src="/static/images/svg/email.svg" alt="" /> */}
                            <input
                                className={style.input}
                                type="text"
                                value={email}
                                placeholder="Email"
                                autoComplete="off"
                                onInput={(e) => setEmail(e.target.value)}
                            />
                        </label>

                        <label className={style.inputLabel}>
                            <div className={style.inputSvgBlock}>
                                <img src="/static/images/svg/key.svg" alt="" />
                            </div>
                            <input
                                className={style.input}
                                type="password"
                                value={password}
                                placeholder={t("registration.password")}
                                autoComplete="off"
                                onInput={(e) => setPassword(e.target.value)}
                            />

                        </label>
                        <div className="flex gap-2 px-2">
                            <label className="font-light text-left">
                                <input
                                    checked={
                                        userType === "individual"
                                    }
                                    type="radio"
                                    value="individual"
                                    onChange={(e) =>
                                        setUserType(e.target.value)
                                    }
                                />
                                <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                                    {t("registration.individual_user")}
                                </span>
                            </label>
                            <label className="font-light text-left">
                                <input
                                    checked={
                                        userType === "legal"
                                    }
                                    type="radio"
                                    value="legal"
                                    onChange={(e) =>
                                        setUserType(e.target.value)
                                    }
                                />
                                <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                                    {t("registration.juridical_user")}
                                </span>
                            </label>
                        </div>
                    </div>

                    <button
                        className={style.button}
                        onClick={handleButtonClick}
                    >
                        {t("registration.registrate_button")}
                    </button>
                    <Link
                        onClick={redirectToAuthentication}
                        className="mt-4 text-2xs text-gray-600 cursor-pointer"
                    >
                        {t("registration.authentication_link")}
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default RegistrationPage;
